<template>
    <div class="header-button button-basket goal-goto-basket" @click="openBasket">
        <span class="balloon basket-total" v-if="total_quantity > 0">{{total_order_sum}}</span>
        <span class="pp-icon pp-icon-basket"></span>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Utils from "../Utils";

    export default {
        name: "ButtonBasket",
        computed:{
            ...mapGetters('order', {
                total: 'total',
            }),
        },
        methods:{
            ...mapActions({
                openBasket: 'order/open',
            }),
        },
      mounted() {
        this.calculateDiscount();
      },
      mixins: [Utils],
    }
</script>

<style scoped>

</style>
